<!-- components/EditForm.vue -->
<template>
    <div class="edit-form">
        <div>
            <div class="form_div">
                <el-input v-model="yzm" placeholder="请输入验证码"></el-input>
                <el-button type="primary" @click="emailYzmSent" id="buttonEmailYzmSent"
                    :disabled="emailCountdown > 0">{{ emailCountdown > 0 ? `${emailCountdown}s 后重发` : '发送验证码'
                    }}</el-button>
            </div>
            <div v-show="types == 'as'" class="form_div">
                <div>新用户名：</div>
                <el-input v-model="userName" placeholder="请输入新的用户名"></el-input>
            </div>
            <div v-show="types == 'pa'" class="form_div">
                <div>新密码：</div>
                <el-input v-model="newPassWord" placeholder="请输入新的密码"></el-input>
            </div>
            <div v-show="types == 'pa'" class="form_div">
                <div>再次输入：</div>
                <el-input v-model="newPassWordAgain" placeholder="请再次输入密码"></el-input>
            </div>
            <div v-show="types == 'em'" class="form_div">
                <div>新邮箱：</div>
                <el-input v-model="newEmil" placeholder="请输入新的邮箱"></el-input>
            </div>
        </div>
        <div>
            <el-button type="primary" @click="submitData" class="" v-show="verify_types">提交</el-button>
            <el-button type="primary" @click="close" class="">取消</el-button>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行

export default {
    name: 'ModifyUserIntroduce',
    props: {
        types: {
            type: String // [as, pa, em]
        },
    },
    data() {
        return {
            yzm: "",
            userName: "",
            newPassWord: "",
            newPassWordAgain: "",
            newEmil: "",
            emailCountdown: 0,
            isEmailSending: false,
            countdownInterval: null,
            verify_types: false
        }
    },
    methods: {
        async submitData() {
            console.log("提交");
            if (!this.verify_types) {
                this.$messageX.xiaoxiti("e", `系统运行错误！`);
                return;
            }
            if (this.types == 'em') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!this.newEmil || !emailRegex.test(this.newEmil)) {
                    this.$messageX.xiaoxiti("w", "请输入有效的邮箱地址");
                    return;
                }
            }
            if (this.types == 'pa') {
                if (this.newPassWord != this.newPassWordAgain) {
                    this.$messageX.xiaoxiti("e", `两次输入的密码不相同！`);
                    return;
                }
                if (!this.$messageX.validatePassword(this.newPassWord)) {
                    this.$messageX.xiaoxiti("w", `密码不符合：长度8-20位，必须包含大写、小写、数字、特殊字符！`);
                    return;
                }
            }
            if (this.types == 'as') {
                if (this.userName.replace(/\s+/g, '') == "") {
                    this.$messageX.xiaoxiti("e", `请输入有效用户名！`);
                    return;
                }

            }

            try {
                const res = await request.post('/ReviseData', {
                    types: this.types,
                    yzm: this.yzm,
                    userName: this.userName,
                    newPassWord: this.newPassWord,
                    newEmil: this.newEmil
                });
                this.$messageX.xiaoxiti("c", res.message);
                if (res.response.isrefresh) {
                    localStorage.clear();
                    location.reload();
                    this.$messageX.xiaoxiti("w", "当前登录状态已失效！请重新登录！");
                } else {
                    this.close();
                }
            } catch (err) {
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },
        close() {
            this.$emit('close');
        },
        async emailYzmSent() {
            // 校验邮箱格式（可选增强）
            if (this.isEmailSending) return;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!this.newEmil || !emailRegex.test(this.newEmil)) {
                this.$messageX.xiaoxiti("w", "请输入有效的邮箱地址");
                return;
            }
            // 如果正在倒计时，直接返回
            if (this.emailCountdown > 0) return;

            this.isEmailSending = true;
            try {
                const email = encodeURIComponent(JSON.parse(localStorage.getItem('userData')).user.user.MailBox);
                const res = await fetch(`//www.aboluo.site/api/EmailYanZhenMaHuoQu/${email}?t=${Date.now()}`);
                const data = await res.json();
                if (data.success) {
                    this.$messageX.xiaoxiti("i", `邮件已发送至【${this.form.email}】`);
                    // 可加倒计时禁用按钮（如 60 秒）
                    this.startEmailCountdown(120);
                } else {
                    this.$messageX.xiaoxiti("e", data.message);
                }
            } finally {
                setTimeout(() => {
                    this.isEmailSending = false;
                }, 60000); // 60秒内禁止再次发送
            }
        },
        startEmailCountdown(seconds) {
            // 清除可能存在的旧定时器
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }

            this.emailCountdown = seconds;

            this.countdownInterval = setInterval(() => {
                this.emailCountdown--;
                if (this.emailCountdown <= 0) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
            }, 1000);
        }
    },
    mounted() {
        var a = ["as", "pa", "em"]
        if (!a.includes(this.types)) {
            this.verify_types = false;
            console.error(`types传值错误！【${this.types}】`);
            confirm("系统内部错误！请联系管理员！");
        } else {
            this.verify_types = true;
        }
    },
    beforeUnmount() {

    },
    watch: {

    },
}
</script>

<style scoped>
.edit-form {
    display: flex;

}

.form_div {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 10px;
    width: 100%;
}
</style>